import { c as _c } from "react/compiler-runtime";
import type { HometownNewsApiDto } from '__generated__/api/unauth/types.gen';
import { Fragment } from 'react';
import { SearchCategoryAdSlot } from '@/app/_components/ads';
import { ROUTES } from '@/constants';
import { buildDetailSlug } from '@/utils/detailSlug';
import { formatDateLabel } from '../../utils';
import { SearchContentsCard } from '../SearchContentsCard';
import { SearchEmptyResults } from '../SearchEmptyResults';
export function HometownNewsList(t0) {
  const $ = _c(7);
  const {
    items
  } = t0;
  if (items.length < 1) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SearchEmptyResults />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== items) {
    let t2;
    if ($[3] !== items.length) {
      t2 = (item, index) => <Fragment key={item.hometownNewsIdIdx ?? item.hometownNewsId}><SearchCategoryAdSlot as="li" placement="search-hometowns" position={index + 1} listLength={items.length} /><li><SearchContentsCard imageSrc={item.thumbnail} title={item.hometownNewsName} content={item.summary} daysAgo={formatDateLabel(item.publishedAt) || item.daysAgo} link={ROUTES.HOMETOWN_NEWS_DETAIL.pathname({
            idIdx: item.slugId ?? buildDetailSlug(item.hometownNewsIdIdx ?? "", item.hometownNewsName)
          })} /></li></Fragment>;
      $[3] = items.length;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = items.map(t2);
    $[1] = items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <ul className="flex flex-col gap-12 pb-20 mobile-tablet:gap-0 mobile-tablet:divide-y mobile-tablet:divide-Gray-100 mobile-tablet:pb-0">{t1}</ul>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}